import { gql, TypedDocumentNode } from "@apollo/client";

import { RunMinutesUsage, RunMinutesUsageInput } from "types/generated";

type GetRunMinutesUsageData = {
  runMinutesUsage: Pick<
    RunMinutesUsage,
    "window" | "dailyByRunType" | "dailyByRunState" | "totals"
  >;
};

type GetRunMinutesUsageVariables = {
  input: RunMinutesUsageInput;
};

export const GET_RUN_MINUTES_USAGE: TypedDocumentNode<
  GetRunMinutesUsageData,
  GetRunMinutesUsageVariables
> = gql`
  query GetRunMinutesUsage($input: RunMinutesUsageInput!) {
    runMinutesUsage(input: $input) {
      window {
        start
        end
      }
      dailyByRunType {
        day
        runType
        minutes
      }
      dailyByRunState {
        day
        runState
        minutes
      }
      totals {
        publicMinutes
        privateMinutes
      }
    }
  }
`;
